<div class="w-dvw h-svh flex fixed left-0 top-0">
  <aside class="w-sm h-svh pt-32 bg-blue-500">
    <app-sidebar />
  </aside>

  <div class="w-full h-svh px-16 pt-32 overflow-y-auto">
    <router-outlet />
  </div>
</div>
